export enum UserRoles {
  PanelSection = 'PANEL_SECTION',
  Support = 'SUPPORT',
  CompanyMember = 'COMPANY_MEMBER',
  CompanyOwner = 'COMPANY_OWNER',
  SuperAdmin = 'SUPER_ADMIN'
}